import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  LinearProgress,
  Typography,
} from '@mui/material';
import { ReactElement } from 'react';

const OverallMaturityScore = ({ overviewData }: any): ReactElement => (
  <Card variant="outlined">
    <CardHeader
      title={
        <Typography variant="h5" fontWeight={700}>
          Overall Maturity Score
        </Typography>
      }
      subheader={
        <Typography fontSize={16} color="#7E7E7E" fontWeight={500} mt={3}>
          {overviewData?.scoreSummary?.answered || 0} of{' '}
          {overviewData?.scoreSummary?.totalQuestions || 0} questions answered (
          <span style={{ textTransform: 'capitalize' }}>
            {overviewData?.mode || ''}{' '}
          </span>{' '}
          mode)
        </Typography>
      }
    />
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <LinearProgress
          variant="determinate"
          value={overviewData?.scoreSummary?.answeredPercent || 0}
          sx={{
            flex: 1,
            height: 22,
            borderRadius: 999,
            background: '#f1f5f4',
            '& .MuiLinearProgress-bar': { background: '#D1F27A' },
          }}
        />
        <Typography fontWeight={600}>
          {overviewData?.scoreSummary?.answeredPercent || 0}%
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }} mt={5}>
        <Chip
          sx={() => {
            const score = overviewData?.scoreSummary?.scorePercent ?? 0;

            if (score < 20) {
              return {
                background: '#FEF2F2',
                color: '#DC2626',
                fontWeight: 600,
              };
            }
            if (score < 40) {
              return {
                background: '#FFF7ED',
                color: '#EA580C',
                fontWeight: 600,
              };
            }
            if (score < 60) {
              return {
                background: '#FEFCE8',
                color: '#CA8A04',
                fontWeight: 600,
              };
            }
            if (score < 80) {
              return {
                background: '#EFF6FF',
                color: '#2563EB',
                fontWeight: 600,
              };
            }
            return {
              background: '#F0FDF4',
              color: '#16A34A',
              fontWeight: 600,
            };
          }}
          label={overviewData?.scoreSummary?.maturityLevel || '-'}
          size="small"
        />
        <Typography fontSize={16} color="#7E7E7E" fontWeight={500}>
          {overviewData?.scoreSummary?.maturityDescription}
        </Typography>
      </Box>
      <Typography fontSize={16} color="#7E7E7E" fontWeight={500} mt={5}>
        Score: {overviewData?.scoreSummary?.score || 0} /{' '}
        {overviewData?.scoreSummary?.maxScore || 0}
      </Typography>
    </CardContent>
  </Card>
);

export default OverallMaturityScore;
